// local imports
import { ReactComponent as Doctor } from 'assets/icons/doctor.svg'
import useGetHealthServiceChartData from './hooks/use-get-health-service-data'
import DoughnutChartPage from '../../chart-molecules/DoughnutPage/DoughnutChartPage'
import StackedChart from '../../chart-molecules/StackedChart/StackedChart'
import { DropdownWrapper, StyledDropdown } from './styled'
import HealthServiceDist from 'components/dashboard/chart-templates/chartcardpage/tabs/HealthServiceDist'

export default function HealthServiceCharts(props: {
  userInfo: any
  firmList: any
  startDate: Date
  endDate: Date
  selectedFirms: any
}) {
  const {
    t,
    excelData,
    chartType,
    chartTypeOptions,
    handleChartTypeChange,
    items,
    labels,
    colors,
    detailTitle,
    footerTitle,
  } = useGetHealthServiceChartData(props)

  const translatedLabels = labels.map((label) => t(label))

  return (
    <HealthServiceDist excelData={excelData}>
      <div className="row">
        {(props.firmList.length > 1 || props.userInfo === 'SuperAdmin') && (
          <div className="col-3 d-flex justify-content-between flex-column">
            <DropdownWrapper>
              <StyledDropdown
                appendTo="self"
                value={chartType}
                onChange={handleChartTypeChange}
                options={chartTypeOptions}
                optionLabel="value"
                optionValue="key"
              />
            </DropdownWrapper>

            <DoughnutChartPage
              icon={<Doctor width={24} height={24} />}
              items={chartType !== 'all' ? undefined : items}
              colors={colors}
              labels={translatedLabels}
              detailTitle={t(detailTitle)}
              totalNotification={items?.doughnutItems.total}
            />

            <div>
              <span style={{ fontSize: '14px' }}>{t(footerTitle)}</span>
            </div>
          </div>
        )}

        <div className={props.firmList.length > 1 || props.userInfo === 'SuperAdmin' ? 'col-9 ' : 'col-12'}>
          <StackedChart
            chartId="healthChart"
            tabIndex={5}
            colors={colors}
            labels={translatedLabels}
            checkedValue={''}
            setCheckedValue={''}
            response={items}
            userInfo={props.userInfo}
            tooltipLabel={t('dashboard.on-campus-tabs.tooltipMsg')}
          />
        </div>
      </div>
    </HealthServiceDist>
  )
}
